import { Component, Input } from '@angular/core';
import { IndicatorData } from 'app/models/indicator.interface';

@Component({
  selector: 'app-indicator-chip-wrapper',
  templateUrl: './indicator-chip-wrapper.component.html',
  standalone: false
})
export class IndicatorChipWrapperComponent {
  @Input() indicator?: IndicatorData;
}
